import React, { ReactNode } from 'react'

import classNames from 'classnames'
import AccordionItem from 'shared/components/Accordion/AccordionItem'

import classes from './FAQ.module.scss'
import { FaqQuestions } from './questions'

type Props = {
  questions?: FaqQuestionType[]
  title?: string
  titleUppercase?: boolean
  isReveal?: boolean
}

export type FaqQuestionType = {
  title: string
  descr?: string
  children?: ReactNode
}

export const Faq = ({
  questions = FaqQuestions,
  title,
  titleUppercase,
  isReveal = true,
}: Props): JSX.Element => {
  const titleClasses = classNames([classes.title], 'second-title', {
    uppercase: titleUppercase,
  })
  const divAttributes = isReveal
    ? {
        className: 'container reveal-from-bottom-medium',
        ['data-reveal-delay']: 50,
      }
    : {
        className: 'container',
      }

  return (
    <div {...divAttributes}>
      {title && <h2 className={titleClasses}>{title}</h2>}
      <div className="questions-container">
        {questions.map((question, questionIndex) => (
          <AccordionItem
            key={questionIndex}
            title={question.title}
            descr={question?.descr || ''}
          >
            {question?.children}
          </AccordionItem>
        ))}
      </div>
    </div>
  )
}
